module.exports = ['$http', function ($http) {
    let lastGeneratedId = 0;
    let datamodel = {};
    let oldDatamodel = {};

    let isReady = new Promise((resolve) => {
        //get the modeltypes and feed our object
        $http.get('/modeltypes').then((response) => {
            angular.merge(datamodel, response.data);
            oldDatamodel = angular.copy(datamodel);

            resolve(datamodel);
        });
    });

    function save() {
        return new Promise((resolve) => {
            $http.put('/modeltypes', datamodel).then((response) => {

                // //remove all datamodel data
                // angular.merge(datamodel, response.data);
                // oldDatamodel = angular.copy(datamodel);
                //
                //resolve(datamodel);

                angular.forEach(datamodel, (model, index) => {
                    delete datamodel[index];
                    datamodel[index] = response.data[index];
                });

                oldDatamodel = angular.copy(datamodel);

                resolve(response);
            });
        });
    }

    function resetData() {
        angular.forEach(datamodel, (model, index) => {
            delete datamodel[index];
            datamodel[index] = angular.copy(oldDatamodel[index]);
        });
    }

    function isDirty() {
        let newData = JSON.stringify(datamodel);
        let oldData = JSON.stringify(oldDatamodel);
        return !angular.equals(JSON.parse(newData), JSON.parse(oldData));
    }

    return {
        isReady: isReady,
        data: datamodel,
        generateId: function () {
            return --lastGeneratedId;
        },
        save: save,
        isDirty: isDirty,
        resetData: resetData,
        colors: [
            ['#FF9800', '#FFD41E', '#F25FA4', '#4EBED4', '#86be40', '#c9252c'],
            ['#3b5998', '#333333', '#CBCBCB', '#715ea1', '#795548', '#50acee'],
            // ['#86be40', '#4EBED4', '#F25FA4', '#FFD41E', '#c9252c', '#808080', '#6b7e5d', '#333333', '#715ea1', '#FF9800'],
            // ['#795548', '#355122', '#95782d', '#0c879c', '#b82075', '#CBCBCB', '#ffffff', '#aaaaaa', '#50acee', '#3b5998']
        ],
        icons: [
            ['share-alt', 'facebook', 'twitter', 'whatsapp'],
            ['phone', 'reddit', 'flickr', 'youtube'],
            ['instagram', 'pinterest', 'send', 'windows'],
            ['wechat', 'google-plus', 'snapchat', 'vine']
        ]
    }
}];